// /Users/redis/Downloads/custom-posting-ui/frontend/src/components/layout/SidebarNavigation.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../common/Icon';
import { PATHS } from '../../router.jsx';
import { useModal } from '../../contexts/ModalContext';
import { MODAL_TYPES } from '../common/GlobalModals';

const SidebarNavigation = () => {
  const { openModal } = useModal();
  const [hoveredItem, setHoveredItem] = React.useState(null);

  const handleCreateButtonClick = (e) => {
    e.preventDefault();
    openModal(MODAL_TYPES.CREATE_NEW_CONTENT_SELECTION);
  };

  // SIDEBAR CONTAINER
  const sidebarStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    width: '275px',
    backgroundColor: '#2F81F7',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    zIndex: 100,
    borderRight: '1px solid rgba(255,255,255,0.1)',
    overflowY: 'auto',
    overflowX: 'hidden'
  };

  // LOGO SECTION AT TOP
  const logoSectionStyle = {
    padding: '12px 0 0 12px',
    marginBottom: '8px'
  };

  const logoStyle = {
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    color: 'white',
    fontSize: '1.75rem'
  };

  // NAVIGATION ITEMS
  const navItemsContainerStyle = {
    flex: 1,
    padding: '0 12px'
  };

  const navItemStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '9999px',
    marginBottom: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    fontSize: '1.25rem',
    fontWeight: '400',
    position: 'relative'
  };

  const iconStyle = {
    fontSize: '1.625rem',
    marginRight: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '26px'
  };

  const textStyle = {
    fontSize: '1.25rem',
    fontWeight: '400',
    color: 'white'
  };

  // CREATE POST BUTTON
  const createButtonStyle = {
    backgroundColor: 'white',
    color: '#2F81F7',
    borderRadius: '9999px',
    padding: '16px',
    margin: '16px 12px',
    fontSize: '1.0625rem',
    fontWeight: '700',
    textAlign: 'center',
    cursor: 'pointer',
    border: 'none',
    width: 'calc(100% - 24px)',
    transition: 'background-color 0.2s'
  };

  // PROFILE SECTION AT BOTTOM
  const profileSectionStyle = {
    padding: '12px',
    marginTop: 'auto',
    borderTop: '1px solid rgba(255,255,255,0.2)'
  };

  const profileButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '9999px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    width: '100%',
    border: 'none',
    backgroundColor: 'transparent'
  };

  const profileImageStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: 'white',
    color: '#2F81F7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.25rem',
    fontWeight: '600',
    marginRight: '12px'
  };

  const profileInfoStyle = {
    flex: 1,
    textAlign: 'left'
  };

  const profileNameStyle = {
    fontSize: '0.9375rem',
    fontWeight: '700',
    marginBottom: '2px',
    color: 'white'
  };

  const profileHandleStyle = {
    fontSize: '0.9375rem',
    color: 'rgba(255,255,255,0.7)'
  };

  const moreIconStyle = {
    fontSize: '1.25rem',
    color: 'white'
  };

  const getNavItemStyle = (itemName) => ({
    ...navItemStyle,
    backgroundColor: hoveredItem === itemName ? 'rgba(255,255,255,0.1)' : 'transparent'
  });

  return (
    <aside style={sidebarStyle} role="navigation" aria-label="Main navigation">
      {/* LOGO */}
      <div style={logoSectionStyle}>
        <NavLink to={PATHS.HOME} style={logoStyle}>
          <Icon name="home" size={30} />
        </NavLink>
      </div>

      {/* NAVIGATION ITEMS */}
      <div style={navItemsContainerStyle}>
        <NavLink 
          to={PATHS.HOME} 
          style={getNavItemStyle('home')}
          onMouseEnter={() => setHoveredItem('home')}
          onMouseLeave={() => setHoveredItem(null)}
        >
          <div style={iconStyle}>
            <Icon name="home" size={26} />
          </div>
          <span style={textStyle}>Home</span>
        </NavLink>

        <NavLink 
          to={PATHS.EXPLORE} 
          style={getNavItemStyle('explore')}
          onMouseEnter={() => setHoveredItem('explore')}
          onMouseLeave={() => setHoveredItem(null)}
        >
          <div style={iconStyle}>
            <Icon name="search" size={26} />
          </div>
          <span style={textStyle}>Explore</span>
        </NavLink>

        <NavLink 
          to="/messages" 
          style={getNavItemStyle('messages')}
          onMouseEnter={() => setHoveredItem('messages')}
          onMouseLeave={() => setHoveredItem(null)}
        >
          <div style={iconStyle}>
            <Icon name="message-square" size={26} />
          </div>
          <span style={textStyle}>Messages</span>
        </NavLink>

        <NavLink 
          to={PATHS.VIDEO_REELS} 
          style={getNavItemStyle('reels')}
          onMouseEnter={() => setHoveredItem('reels')}
          onMouseLeave={() => setHoveredItem(null)}
        >
          <div style={iconStyle}>
            <Icon name="play-circle" size={26} />
          </div>
          <span style={textStyle}>Reels</span>
        </NavLink>

        <NavLink 
          to={PATHS.EVENTS_MAP} 
          style={getNavItemStyle('map')}
          onMouseEnter={() => setHoveredItem('map')}
          onMouseLeave={() => setHoveredItem(null)}
        >
          <div style={iconStyle}>
            <Icon name="map" size={26} />
          </div>
          <span style={textStyle}>Map</span>
        </NavLink>

        <NavLink 
          to={PATHS.MORE} 
          style={getNavItemStyle('more')}
          onMouseEnter={() => setHoveredItem('more')}
          onMouseLeave={() => setHoveredItem(null)}
        >
          <div style={iconStyle}>
            <Icon name="grid" size={26} />
          </div>
          <span style={textStyle}>More</span>
        </NavLink>
      </div>

      {/* CREATE POST BUTTON */}
      <button
        style={createButtonStyle}
        onClick={handleCreateButtonClick}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
      >
        Create
      </button>
    </aside>
  );
};

export default SidebarNavigation;
